<!-- ----------------------------------------------- -->
<template>
  <v-col class="radar pa-0">
    <div class="rd-card-list">
      <div class="rd-scroll pb-2">
        <rd-movie></rd-movie>
        <rd-number></rd-number>
        <!-- <rd-sns></rd-sns> -->
        <rd-type></rd-type>
      </div>
    </div>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [pc]レーダ雨量画面
 * Radar.vue
 * @author LIS
 */
import mixin from "../../../lib/mixin.js";
import util from "../../../lib/util";
import RdType from "../../../components/pc/RdType.vue";
import RdNumber from "../../../components/pc/RdNumber.vue";
import RdMovie from "../../../components/pc/RdMovie.vue";
// import RdSns from "../../../components/pc/RdSns.vue";

export default {
  mixins: [mixin],
  components: {
    RdType,
    RdNumber,
    RdMovie,
    // RdSns,
  },
  created() {
    this.$log.debug("[radar] created()");
    const urlTime = this.$route.query["rdtime"];
    const urlType = this.$route.query["rdtype"];
    const urlNum = this.$route.query["rdnum"];
    const urlInt = this.$route.query["rdint"];
    const urlOpa = this.$route.query["rdopa"];
    if (urlTime != undefined) {
      // 日付形式をチェック
      let setTime = new Date();
      if (util.formatDate(urlTime) !== "Invalid Date") {
        setTime = util.toDate(urlTime);
      }
      // 5分単位に丸める
      setTime.setMinutes(Math.floor(setTime.getMinutes() / 5) * 5);
      this.$store.commit("app/setTime", setTime);
    }
    if (urlType != undefined) {
      this.$store.commit(
        "radar/setType",
        urlType == "xrain" ? "xrain" : "cband"
      );
    }
    if (urlNum != undefined) {
      this.$store.commit("radar/setNumber", urlNum == 4 ? 4 : 1);
      if (urlNum == 4 && (urlInt == 5 || urlInt == 30 || urlInt == 60)) {
        this.$store.commit("radar/setInterval", Number(urlInt));
      }
    }
    if (urlOpa != undefined) {
      this.$store.commit("radar/setOpacity", (Number(urlOpa) / 10) * 10);
    }
    this.$store.commit(
      "radar/setHistoryPlayTime",
      this.$store.state.app.appTime
    );
    this.replaceRadarQueryForPc();
  },
  mounted() {
    this.$log.debug("[radar] mounted()");
    this.$store.commit("radar/resetHistoryPlay");
    this.$store.commit("app/setContent", "Radar");
  },
  beforeDestroy() {
    this.$log.debug("[radar] beforeDestroy()");
    this.$store.commit("radar/resetHistoryPlay");
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.radar {
  height: 100%;
  .rd-card-list {
    position: relative;
    height: 100%;
  }
  .rd-scroll {
    position: absolute;
    height: 100%;
    overflow: auto;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    & > :not(:first-child) {
      margin-top: 4px;
    }
  }
}
</style>
